import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import AdminNavbar from "../AdminNavbar";
import Footer from "../../components/common/Footer";
import "../../assets/css/admin/uploadPhoto.css";

import { CLOUDINARY_URL, UPLOAD_PRESET } from "../../services/cloudinary";

import { db } from "../../firebase/firebase";
import {
    collection,
    addDoc,
    getDocs,
    serverTimestamp
} from "firebase/firestore";

function UploadPhoto() {

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [category, setCategory] = useState("");
    const [categories, setCategories] = useState([]);
    const [image, setImage] = useState(null);

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});
    useEffect(() => {

        loadCategories();

    }, []);

    const loadCategories = async () => {

        try {

            const snapshot = await getDocs(
                collection(db, "gallery_categories")
            );

            const list = [];

            snapshot.forEach((doc) => {

                list.push({

                    id: doc.id,
                    ...doc.data()

                });

            });

            setCategories(list);

       } catch (error) {

    console.error("Upload Error:", error);

    let errorMessage = "Something went wrong while uploading.";

    // Cloudinary errors
    if (error.message) {

        errorMessage = error.message;

    }

    // Network error
    if (!navigator.onLine) {

        errorMessage = "No Internet Connection. Please check your network.";

    }

    setPopup({

        show: true,

        type: "error",

        message: errorMessage

    });

    setTimeout(() => {

        setPopup({

            show: false,

            type: "",

            message: ""

        });

    }, 5000);

} finally {

    setLoading(false);

}

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        let validationErrors = {};

        if (!title.trim()) {

            validationErrors.title =
                "Please enter the photo title.";

        }

        if (!category) {

            validationErrors.category =
                "Please select a category.";

        }

        if (!description.trim()) {

            validationErrors.description =
                "Please enter the description.";

        }

        if (!image) {

            validationErrors.image =
                "Please choose a photo.";

        }

        if (Object.keys(validationErrors).length > 0) {

            setErrors(validationErrors);

            return;

        }

        setErrors({});

        setLoading(true);

        try {

            const formData = new FormData();

            formData.append("file", image);

            formData.append(
                "upload_preset",
                UPLOAD_PRESET
            );

            const response = await fetch(

                CLOUDINARY_URL,

                {

                    method: "POST",

                    body: formData

                }

            );

          const data = await response.json();

if (!response.ok) {

    throw new Error(
        data.error?.message ||
        data.message ||
        "Cloudinary upload failed."
    );

}

if (!data.secure_url) {

    throw new Error("Cloudinary did not return an image URL.");

}

            const selectedCategory = categories.find(

                (cat) => cat.id === category

            );

            try {

    await addDoc(

        collection(db, "photos"),

        {

            title,

            description,

            category: selectedCategory.title,

            imageUrl: data.secure_url,

            createdAt: serverTimestamp()

        }

    );

} catch (firestoreError) {

    throw new Error(
        "Photo uploaded to Cloudinary but failed to save in Firebase."
    );

}

         setPopup({
    show: true,
    type: "success",
    message: "Photo Uploaded Successfully"
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

            setTitle("");
            setDescription("");
            setCategory("");
            setImage(null);

            document.getElementById(
                "photoInput"
            ).value = "";

        } catch (error) {

            console.log(error);

            setPopup({
    show: true,
    type: "error",
    message: "Upload Failed. Please Try Again."
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        } finally {

            setLoading(false);

        }

    };
        return (

        <>
            {popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success"
                ? "✓"
                : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>

                {popup.message}

            </p>

        </div>

    </div>

)}
            <AdminNavbar />

            <div className="dashboard-container">

                <Sidebar />

                <div className="upload-container">

                    <div className="upload-header">

                        <h1>Upload New Photo</h1>

                        <p>
                            Upload premium photographs to your Story Line Studios gallery.
                        </p>

                    </div>

                    <div className="upload-card">

                        {/*======================
                            LEFT SIDE PREVIEW
                        =======================*/}

                        <div className="preview-panel">

                            {image ? (

                                <img
                                    src={URL.createObjectURL(image)}
                                    alt="Preview"
                                    className="preview-image"
                                />

                            ) : (

                                <div className="empty-preview">

                                    <div className="camera-icon">
                                        📸
                                    </div>

                                    <h2>
                                        Live Preview
                                    </h2>

                                    <p>
                                        Select a photo to see
                                        a live preview before uploading.
                                    </p>

                                </div>

                            )}

                        </div>

                        {/*======================
                            RIGHT SIDE FORM
                        =======================*/}

                        <form
                            className="upload-form"
                            onSubmit={handleSubmit}
                        >

                            <label>
                                Photo Title
                            </label>

                            <input
                                type="text"
                                placeholder="Enter Photo Title"
                                value={title}
                                onChange={(e) => {

                                    setTitle(e.target.value);

                                    setErrors({

                                        ...errors,

                                        title: ""

                                    });

                                }}
                            />

                            {errors.title && (

                                <p className="error-text">

                                    {errors.title}

                                </p>

                            )}

                            <label>
                                Category
                            </label>

                            <select
                                value={category}
                                onChange={(e) => {

                                    setCategory(e.target.value);

                                    setErrors({

                                        ...errors,

                                        category: ""

                                    });

                                }}
                            >

                                <option value="">
                                    Select Category
                                </option>

                                {categories.map((cat) => (

                                    <option
                                        key={cat.id}
                                        value={cat.id}
                                    >

                                        {cat.title}

                                    </option>

                                ))}

                            </select>

                            {errors.category && (

                                <p className="error-text">

                                    {errors.category}

                                </p>

                            )}

                            <label>
                                Description
                            </label>

                            <textarea
                                rows="5"
                                placeholder="Enter Photo Description"
                                value={description}
                                onChange={(e) => {

                                    setDescription(e.target.value);

                                    setErrors({

                                        ...errors,

                                        description: ""

                                    });

                                }}
                            />

                            {errors.description && (

                                <p className="error-text">

                                    {errors.description}

                                </p>

                            )}

                            <label>
                                Select Photo
                            </label>

                            <input
                                id="photoInput"
                                type="file"
                                accept="image/*"
                                onChange={(e) => {

                                    setImage(e.target.files[0]);

                                    setErrors({

                                        ...errors,

                                        image: ""

                                    });

                                }}
                            />

                            {errors.image && (

                                <p className="error-text">

                                    {errors.image}

                                </p>

                            )}

                            {loading && (

                                <div className="uploading-text">

                                    📤 Uploading Photo...
                                    Please wait...

                                </div>

                            )}

                            <button
                                type="submit"
                                disabled={loading}
                            >

                                {loading
                                    ? "Uploading..."
                                    : "Upload Photo"}

                            </button>

                        </form>

                    </div>

                </div>

            </div>

            <Footer />

        </>

    );

}

export default UploadPhoto;